import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import {
  deleteOrganization,
  fetchOrganization,
} from '../../actions/organizationActions'
import { selectOrganization } from '../../reducers/organizationReducer'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'
import CollapsibleTableSection from '../../components/collapsibleTableSection'

const OrganizationShowComponent = ({ match, organization, dispatch, history }) => {
  const id = match.params.id
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let mounted = true
    const load = async () => {
      setLoading(true)
      try {
        await dispatch(fetchOrganization(id))
      } finally {
        if (mounted) setLoading(false)
      }
    }
    load()
    return () => {
      mounted = false
    }
  }, [dispatch, id])

  const handleDelete = () => {
    dispatch(deleteOrganization(id)).then(() => history.push('/organizations'))
  }

  const levels = [
    { label: 'Index ', path: '/' },
    { label: 'Organizations', path: '/organizations' },
  ]

  return (
    <>
      <Breadcrumb levels={levels} />
      <LoadingSection isLoading={loading}>
        {organization && (
          <div className="index index__drive-america">
            <h1 className="index-table__header">Organization</h1>
            <div className="index-table__actions">
              <a
                href="/organizations"
                className="button button-drive-america link-drive-america link-drive-america__new-applicant"
              >
                Back
              </a>
              <a
                href={`/organizations/${organization.id}/edit`}
                className="button button-drive-america link-drive-america link-drive-america__new-applicant"
              >
                Edit Organization
              </a>
            </div>
            <table className="index-table">
              <tbody className="index-table__body">
                <CollapsibleTableSection
                  title="Basic Information"
                  rows={[
                    ['Code', organization.code],
                    ['Legal Name', organization.nameLegal],
                    ['DBA Name', organization.nameDba || '—'],
                    [
                      'Configuration',
                      `${organization.configuration?.callCenterName || 'Configuration'} (#${organization.configurationId})`,
                    ],
                  ]}
                />
                <CollapsibleTableSection
                  title="Contact Information"
                  rows={[
                    ['Contact Email', organization.contactEmail || '—'],
                    ['Contact Phone', organization.contactPhone || '—'],
                  ]}
                />
                <CollapsibleTableSection
                  title="Address"
                  rows={[
                    ['Address Line 1', organization.address?.line1 || '—'],
                    ['Address Line 2', organization.address?.line2 || '—'],
                    ['City', organization.address?.city || '—'],
                    ['State', organization.address?.state || '—'],
                    ['Zip', organization.address?.zip || '—'],
                  ]}
                />
              </tbody>
            </table>
          </div>
        )}
      </LoadingSection>
    </>
  )
}

export default connect((state, ownProps) => ({
  organization: selectOrganization(state.organizations, ownProps.match.params.id),
}))(OrganizationShowComponent)
